import React, { useState } from "react";
import styled from "styled-components";
import fipayFonts from "../../theme/index";
import mission from "../../assets/icons/contact-us-2.png";
import TextFields from "../TextField/text-field.component";
import { LoginButtonContainer } from "../Login/login.styles";
import Buttons from "../Button/button.component";
import { colors } from "../../theme/color";
import Modal from "./Modal";

export interface ContactFormValues {
  fullName: string;
  email: string;
  title: string;
  message: string;
}

interface SendMessageProps {
  handleForm: () => void;
  formData: ContactFormValues;
  setFormData: React.Dispatch<React.SetStateAction<ContactFormValues>>;
  isLoading?: boolean;
  errorMessage?: string;
}

const images = [
  {
    imgPath: "/assets/icons/contact-us-2.png",
    TextHeader: "Send Us a Message",
    MidFirstText: `Get in touch with us if you have any questions or want to partner or collaborate with us by sending us a message`,
  },
];

const SendMessage: React.FC<SendMessageProps> = ({
  handleForm,
  formData,
  setFormData,
  isLoading,
  errorMessage,
}) => {
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const handleChange = (key: keyof ContactFormValues, value: string) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };
  const isFormValid = () => {
    return formData.email !== "" && formData.title !== "" && isValidEmail;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleForm();
    setShowModal(true);
    setFormData({
      fullName: "",
      email: "",
      title: "",
      message: "",
    });
  };

  return (
    <SendMessageContainer>
      <ContactImage src={images[0].imgPath} alt="message-us" />
      <ContactText>
        <SendMessageTitleContainer>
          <SendMessageText>CONTACT</SendMessageText>
        </SendMessageTitleContainer>
        <ContactTitle>{images[0].TextHeader}</ContactTitle>
        <FirstParagraph>{images[0].MidFirstText}</FirstParagraph>
        <form onSubmit={handleSubmit}>
          <InputConctractContainer>
            <TextFields
              type="text"
              label="Full Name"
              value={formData.fullName}
              onChange={(value: string) => handleChange("fullName", value)}
            />
            <TextFields
              type="email"
              label="Email Address"
              value={formData.email}
              onChange={(value: string) => handleChange("email", value)}
            />
            <TextFields
              type="text"
              label="Title of your Message"
              value={formData.title}
              onChange={(value: string) => handleChange("title", value)}
            />
            <TextFields
              type="text"
              label="Your Message"
              value={formData.message}
              height="5rem"
              onChange={(value: string) => handleChange("message", value)}
            />
          </InputConctractContainer>
          <LoginButtonContainer>
            <Buttons
              label={"Sign in"}
              width="95%"
              color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
              cursor="pointer"
              border="25px"
              height="50px"
              disabled={!isFormValid()}
            />
          </LoginButtonContainer>
        </form>
      </ContactText>
      {showModal && <Modal onClose={() => setShowModal(false)} />}
    </SendMessageContainer>
  );
};

const SendMessageContainer = styled.section`
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 2rem 0rem 1rem 2rem; /* Adjusted padding */
  justify-content: space-between;

  @media (max-width: 850px) {
    flex-direction: column;
    align-items: center;
    padding: 0rem;
  }
`;

const InputConctractContainer = styled.section`
  padding-top: 0rem;
  margin: 0rem;
  padding-bottom: 2rem;
`;

const ContactImage = styled.img`
  width: 80%;
  height: auto;
  padding: 1rem;

  @media (max-width: 850px) {
    width: 90%;
    margin: 0;
    padding: 0;
  }
`;

const ContactText = styled.div`
  width: 50%;
  padding: 4rem 4rem;

  @media (max-width: 850px) {
    width: 80%;
    margin: 1rem;
    padding: 1rem;
  }
`;

const SendMessageText = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: center; /* Corrected typo */
  color: #00c703;
`;

const SendMessageTitleContainer = styled.div`
  background-color: rgba(0, 199, 3, 0.1);
  border-radius: 30px;
  text-align: center;
  display: inline-block;
  width: 8rem;
  height: 1%;
  margin-left: 1rem;
  @media (max-width: 850px) {
    margin: 0rem;
  }
`;

const FirstParagraph = styled.p`
  text-align: left;
  margin-bottom: 2rem;
  color: #5e5e5e;
  padding-left: 1rem;
  ${fipayFonts.fipayFonts.body1}
  @media (max-width: 850px) {
    padding-left: 0rem;
  }
`;

const ContactTitle = styled.h1`
  font-family: GT Walsheim Pro;
  font-size: 45px;
  font-weight: 700;
  line-height: 64px;
  letter-spacing: 0.5px;
  text-align: left;
  margin-bottom: 0px;
  color: #09005b;
  padding-left: 1rem;
  @media screen and (min-width: 0px) and (max-width: 850px) {
    font-size: 26px;
    line-height: 34.35px;
    padding-left: 0rem;
  }
  ${fipayFonts.fipayFonts.heading1};
`;

export default SendMessage;
